
import "./pt-ui-table-link.css"
export default {
  listeners: {
    click: true
  }
}